import React from "react";
import { Route, Routes } from "react-router-dom";
import * as Views from "./views";

function AdminRoutes(){
  return (
    <Routes>
      <Route path="ai-logs" exact={true} element={<Views.AILogs></Views.AILogs>} />
      <Route path="posts" exact={true} element={<Views.Posts></Views.Posts>} />
      <Route path="user-details" exact={true} element={<Views.UserDetails></Views.UserDetails>} />
      <Route path="workspace-details" exact={true} element={<Views.WorkspaceDetails></Views.WorkspaceDetails>} />
      <Route path="content-generation-feedbacks" exact={true} element={<Views.ContentGenerationFeedbacks></Views.ContentGenerationFeedbacks>} />
      <Route path="code-redemptions" exact={true} element={<Views.CodeRedemptions></Views.CodeRedemptions>} />
      <Route path="transfer-admin-rights" exact={true} element={<Views.TransferAdminRights></Views.TransferAdminRights>} />
      <Route path="refund" exact={true} element={<Views.Refund></Views.Refund>} />
      <Route path="supergrow-2-whitelist" exact={true} element={<Views.Supergrow2Whitelist />} />
      <Route path="create-api-key" exact={true} element={<Views.CreateApiKey />} />
      <Route path="*" element={<Views.NotFound></Views.NotFound>} />
    </Routes>
  );
}

export default AdminRoutes;
